
function floorFixed(n, prec) {
  const k = Math.pow(10, prec);
  return Math.floor(Math.round(n * k * 10) / 10) / k;
}


function number_format(number, decimals, dec_point, thousands_sep) {
  // Strip all characters but numerical ones.
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep;
  const dec = (typeof dec_point === 'undefined') ? '.' : dec_point;
  let s = '';

  const toFixedFix = function(n, prec) {
    return '' + floorFixed(n, prec);
  };

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}


function amountToInt(amount, store) {
  if (typeof amount !== 'string') {
    amount = amount.toString();
  }
  if (store?.priceThousandsSeparator) {
    amount = amount.replace(store.priceThousandsSeparator, '');
  }
  return parseFloat(
    amount
      .replace(store?.symbole || '€', '')
      .replace(store?.priceDecimalSeparator || '.', '.')
  );
}


function floorPrice(price) {
  return floorFixed(price, 2);
}
function stripHtml(html) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
}
function isAmountValid(amount, offers, selectedStore = "digital") {
  const numericValue = Number(amount);

  if (!numericValue || isNaN(numericValue)) {
    return false;
  }

  const isPredefinedSingle = offers.some(
    (offer) =>
      offer?.type === "single" &&
      offer.value === numericValue &&
      offer.availability &&
      offer.availability[selectedStore] > 0
  );
  if (isPredefinedSingle) return true;

  const isPredefinedSlider = offers.some(
    (offer) =>
      offer?.type === "slider" &&
      Array.isArray(offer.values) &&
      offer.values.some(
        (val) =>
          val.value === numericValue &&
          val.availability &&
          val.availability[selectedStore] > 0
      )
  );
  if (isPredefinedSlider) return true;

  if (offers.extra_offers) {
    const isExtraOfferValid = offers.extra_offers.some(
      (offer) =>
        offer?.type === "single" &&
        offer.value === numericValue &&
        offer.availability &&
        offer.availability[selectedStore] > 0
    );
    if (isExtraOfferValid) return true;
  }
  
  const manualOffer = offers.find((offer) => offer?.type === "manual");
  if (manualOffer) {
    const isInManualRange =
      numericValue >= manualOffer.min &&
      (manualOffer.max ? numericValue <= manualOffer.max : true);
    if (isInManualRange) return true;
  }

  return false;
}

export {
  amountToInt,
  floorPrice,
  number_format,
  floorFixed,
  stripHtml,
  isAmountValid
};